
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import Image from "next/image";
import type { GetStaticProps, NextPage } from "next/types";
// import useTranslation from "next-translate/useTranslation";
import { PAGE } from "../../../consts/ppages";
import { getVPerfectById } from "../../../utils/get-page";
interface IVPerfectPage {
    page: {
        title: string;
        vPerfect: {
            title1: string;
            title2: string;
            title3: string;
            title4: string;
            description1: string;
            description2: string;
            description3: string;
            description4: string;
            photos2: {
                photo: {
                    sourceUrl: string;
                };
            }[];
            photos3: {
                photo: {
                    sourceUrl: string;
                };
            }[];
        };
        en: {
            title: string;
            vPerfect: {
                title1: string;
                title2: string;
                title3: string;
                title4: string;
                description1: string;
                description2: string;
                description3: string;
                description4: string;
                photos2: {
                    photo: {
                        sourceUrl: string;
                    };
                }[];
                photos3: {
                    photo: {
                        sourceUrl: string;
                    };
                }[];
            };
        };
    };
}
const VPerfectPage: NextPage<IVPerfectPage> = ({ page }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/pvc/v-perfect", hrefLang: "x-default" },
        { href: "https://knswindows.com/pvc/v-perfect", hrefLang: "en" },
        { href: "https://knsokna.pl/pvc/v-perfect", hrefLang: "pl" },
        { href: "https://knsfenster.de/pvc/v-perfect", hrefLang: "de" },
        { href: "https://kns-okna.eu/pvc/v-perfect", hrefLang: "cs" },
        { href: "https://knsfinestre.it/pvc/v-perfect", hrefLang: "it" },
        { href: "https://knsfenetres.fr/pvc/v-perfect", hrefLang: "fr" },
        { href: "https://knsokna.eu/pvc/v-perfect", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="w-full bg-black text-white">
        <Image alt="V-Perfect" className="w-full" height="729" src="/img/v-perfect.jpg" width="1920"/>
        <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
          <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
            {page?.vPerfect?.title1
        ? page.vPerfect?.title1
        : page?.en?.vPerfect?.title1}
          </h1>
          <div className="py-3">
            {page?.vPerfect?.description1
        ? parse(page?.vPerfect?.description1 || "")
        : parse(page?.en?.vPerfect?.description1 || "")}
          </div>
        </div>
      </div>

      <div className="w-full bg-white text-black">
        <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
          <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
            {page.vPerfect?.title2
        ? page.vPerfect?.title2
        : page?.en?.vPerfect?.title2}
          </h1>
          <div className="py-3">
            {page?.vPerfect?.description2
        ? parse(page?.vPerfect?.description2 || "")
        : parse(page?.en?.vPerfect?.description2 || "")}
          </div>
          <div className="flex flex-wrap justify-center">
            {page?.vPerfect?.photos2?.map((photo, i) => (<div className="p-2" key={i}>
                <Image alt="V-Perfect" className="w-96" height="300" src={photo?.photo?.sourceUrl} width="300"/>
              </div>))}
          </div>
        </div>
      </div>

      <div className="w-full bg-white text-black">
        <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
          <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
            {page.vPerfect?.title3
        ? page.vPerfect?.title3
        : page?.en?.vPerfect?.title3}
          </h1>
          <div className="py-3">
            {page?.vPerfect?.description3
        ? parse(page?.vPerfect?.description3 || "")
        : parse(page?.en?.vPerfect?.description3 || "")}
          </div>
          <div className="flex flex-wrap justify-center">
            {page?.vPerfect?.photos3?.map((photo, i) => (<div className="p-2" key={i}>
                <Image alt="V-Perfect" className="w-96" height="300" src={photo?.photo?.sourceUrl} width="300"/>
              </div>))}
          </div>
        </div>
      </div>

      <div className="w-full bg-black text-center text-gray-400">
        <Image alt="V-Perfect" className="w-full" height="643" src="/img/v-perfect-bg.jpg" width="1920"/>
      </div>

      <div className="w-full bg-white text-black">
        <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
          <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
            {page.vPerfect?.title4
        ? page.vPerfect?.title4
        : page?.en?.vPerfect?.title4}
          </h1>
          <div className="py-3">
            {page?.vPerfect?.description4
        ? parse(page?.vPerfect?.description4 || "")
        : parse(page?.en?.vPerfect?.description4 || "")}
          </div>
        </div>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.VPERFECT[LOCALE as keyof typeof PAGE.VPERFECT] || 1;
    const { page } = await getVPerfectById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default VPerfectPage;

    async function __Next_Translate__getStaticProps__1a19cd2bfaf__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/v-perfect/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bfaf__ as getStaticProps }
  